import ProviderDetails from "../ProviderDetails";
import PlanLists from "../PlanLists";
import { ExternalContainer } from "../../../components/Account/reusables";
import { Header } from "../Header";

const DataPlan = () => {
  return (
    <div className="h-full  w-[full]  lg:px-[56px]">
      <ExternalContainer>
        <div>
          <Header />
          <div className="flex flex-col bp:flex-row items-start gap-12">
            <ProviderDetails />
            <PlanLists
              recipientLabel="Phone Number"
              productType="data"
              additionalInput={false}
              additionalInputPlaceholder="Enter Phone Number"
              additionalInputType="number"
              additionalInputLabel="Amount"
              additionalInputFormName="amount"
            />
          </div>
        </div>
      </ExternalContainer>
    </div>
  );
};

export default DataPlan;
